import {
  ErrorsByGroupId,
  GroupEditionErrors,
  HardGroupEditionErrors,
  SoftGroupEditionErrors,
} from "../models";
import isHardError from "./isHardError";

const toObj = (errors: (keyof GroupEditionErrors)[]): GroupEditionErrors =>
  errors.reduce((acc, error) => ({ ...acc, [error]: true }), {} as GroupEditionErrors);

/**
 * Return a list with two values where the 1st one contains the `hard` errors
 * and the 2nd the `soft` errors, both indexed by the `groupId`
 *
 * @param errorsByGroupId ErrorsByGroupId
 *
 * @return [ErrorsByGroupId, ErrorsByGroupId]
 */
const splitGroupErrors = (errorsByGroupId: ErrorsByGroupId): [ErrorsByGroupId, ErrorsByGroupId] =>
  Object.entries(errorsByGroupId).reduce(
    ([hardErrorsByGroupId, softErrorsByGroupId], [groupId, errors]) => {
      const errorKeys = Object.keys(errors) as (keyof GroupEditionErrors)[];
      const hards = errorKeys.filter(isHardError);
      const softs = errorKeys.filter(error => !isHardError(error));

      if (hards.length > 0) {
        hardErrorsByGroupId[groupId] = toObj(hards as (keyof HardGroupEditionErrors)[]);
      }
      if (softs.length > 0) {
        softErrorsByGroupId[groupId] = toObj(softs as (keyof SoftGroupEditionErrors)[]);
      }

      return [hardErrorsByGroupId, softErrorsByGroupId];
    },
    [{}, {}] as [ErrorsByGroupId, ErrorsByGroupId],
  );

export default splitGroupErrors;
